import { useEffect } from "react";
import Lenis from "lenis";
import axios from "axios";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import Seo from "@/components/Seo";
import Navbar from "@/components/Navbar";
import Admin from "@/components/Admin";
import Skillbuddy from "@/components/Skillbuddy";
import PitchPrep from "@/components/PitchPrep";
import WhatsAppButton from "@/components/WhatsAppButton";
import Hero from "@/components/Hero";
import TechMarquee from "@/components/Marquee";
import WhyUs from "@/components/WhyUs";
import ProductsSection from "@/components/ProductsSection";
import Services from "@/components/Services";
import TechStack from "@/components/TechStack";
import UseCases from "@/components/UseCases";
import Calculator from "@/components/Calculator";
import Process from "@/components/Process";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";

function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="min-h-screen bg-nexlight text-nexink font-sans">
      <Seo
        title="NexOrbit Solutions — Practical Technology Solutions for Real Business Problems"
        siteName="NexOrbit Solutions"
        description="We help businesses build and modernize technology through cloud management, AI and automation, and custom software engineering — plus our own products, Skillbuddy and PitchPrep."
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "NexOrbit Solutions LLP",
          slogan: "INNOVATE | EMPOWER | ELEVATE",
          description: "Cloud management, AI and automation, and custom software engineering.",
          knowsAbout: ["Microsoft Azure", "Amazon Web Services", "Google Cloud", "AI Automation", "Kubernetes", "Terraform"],
        }}
      />
      <div className="grain-overlay" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero />
        <TechMarquee />
        <WhyUs />
        <ProductsSection />
        <Services />
        <TechStack />
        <UseCases />
        <Calculator />
        <Process />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

function Tracker() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.startsWith("/admin")) return;
    axios
      .post(`${process.env.REACT_APP_BACKEND_URL}/api/track`, { path: pathname })
      .catch(() => {});
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <Tracker />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/skillbuddy" element={<Skillbuddy />} />
        <Route path="/pitchprep" element={<PitchPrep />} />
      </Routes>
    </BrowserRouter>
  );
}
